import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/(member)/(protected)/my/settings/account/billing/payments",
)({
  component: () => <Outlet />,
});
